<template>
    <div class="box_M">
        <div class="info_box_m detail">
            <div class="title">简历详情</div>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
export default {
    components: { BottomMenu },

}
</script>

<style>

</style>